import React from 'react';
import ReactDOM from "react-dom/client";

import App from './App';
import createBrowserHistory from './utils/history.js';

const browserHistory = createBrowserHistory;

const root = ReactDOM.createRoot(document.getElementById("main") as HTMLElement);
root.render(
    <App history={browserHistory} />
);
